export const getSafeString = (value: string | number | undefined | null):string => {
    if (value) {
        return String(value);
    }
    return '';
};
